import { Component, OnInit, ViewChild } from '@angular/core';

import { FilterQueryComponent } from '../shared/component/filter-query/filter-query.component';
import { MessageComponent } from '../shared/component/message/message.component';
import { OrderService } from '../shared/service/order.service';
import { UserService } from '../shared/service/user.service';

@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    styleUrls: [ './order.component.css' ],
})
export class OrderComponent extends FilterQueryComponent implements OnInit {
    @ViewChild(MessageComponent) message: MessageComponent;

    reportLink = '/order/order-detail';
    
    multiList: any = {};
    mappedLists: any;
    lastEvent: any;

    totalRecords: number;
    groupedOrders: any;
    rawOrders: any;

    showIds: boolean;

    constructor(
        protected orderService: OrderService,
        protected userService: UserService,
    ) {
        super(userService);
    }

    loadingOnTable: boolean;
    resultLoaded: boolean;
    listsLoaded: boolean;

	ngOnInit() {
        this.loadDistinctListsFromOrder();
    }

    updateData(filter) {
        this.loadingOnTable = true;
        this.message.info('loading_data_message');

        this.queryData = { ...this.queryData, ...filter };

        this.getOrdersByParams();
    }

    loadDistinctListsFromOrder() {
        this.orderService.distinctFiltered({}).subscribe((data) => {
            this.multiList = data && data.length ? data : [];
            this.multiListMapper(data || this.multiList);
        });
    }

    getOrdersByParams() {
        this.queryData.init = this.queryData.first || 0;
        this.queryData.end = this.queryData.rows || 100;

        this.orderService.getPaginated(this.queryData)
            .subscribe(({ count, rows }) => {
                this.rawOrders = rows || [];
                this.totalRecords = count;

                this.ordersMapper(rows);
            }
        );
    }

    ordersMapper(orders) {
        this.groupedOrders = [];

        const groupedOrders = {};

        for (const order of orders) {
            const { order_id, manufacturer_id, product_id, product_color_id } = order;
            const uid = [order_id, manufacturer_id, product_id].join('-'); // product_color_id

            if (!groupedOrders[uid]) groupedOrders[uid] = [];

            groupedOrders[uid].push(order);
        }

        Object.getOwnPropertyNames(groupedOrders).forEach(group => {
            this.groupedOrders.push(groupedOrders[group]);
        });

        this.loadingOnTable = false;
        this.resultLoaded = true;
    }

    // mapToList from another filter query
	multiListMapper(list) {
        const types = Object.getOwnPropertyNames(list);

		const mappedLists = types && types.length ? types.map((key: string) => {
            const values = (list[key]).map((item: any) => {
                return {
                    label: item.value,
                    value: item.id,
                }
            });

			return { key, values };
		}) : [];

		this.mappedLists = mappedLists;
		this.listsLoaded = true;
	}

    calculateBalance(order) {
        const total = order.quantity_origin - (order.quantity_delivered || 0);
        return total > 0 ? total : 0;
    }
}

// interface DistinctList { name: string; values: { id: number, value: string } }



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/order/order.component.ts